<script>
    import StarRating from 'vue-star-rating';
    export default {
        components: {
          StarRating
        },
        props: ['course', 'start_age', 'end_age', 'geoerror'],
        data() {
            return {
                geodistances: this.geoerror === null,
                collapsed: false,
                days: [
                    {name: 'L', long: 'Lunedì', dow: 0, lesson: false},
                    {name: 'M', long: 'Martedì', dow: 1, lesson: false},
                    {name: 'M', long: 'Mercoledì', dow: 2, lesson: false},
                    {name: 'G', long: 'Giovedì', dow: 3, lesson: false},
                    {name: 'V', long: 'Venerdì', dow: 4, lesson: false},
                    {name: 'S', long: 'Sabato', dow: 5, lesson: false},
                    {name: 'D', long: 'Domenica', dow: 6, lesson: false}
                ]
            }
        },
        computed: {
            startFrom() {
                if (this.course.days.length) {
                    let day = _.head(this.course.days).start_time
                    return day.substring(day, day.length - 3)
                }
                return ''
            },
            endTo() {
                if (this.course.days.length) {
                    let day = _.head(this.course.days).end_time
                    return day.substring(0, day.length - 3)
                }
                return ''
            },
            dayHours() {
                let dayHours = []
                this.course.days.forEach(d => {
                    if (d.interval > 0) {
                        let start = moment(`2019-01-01 ${d.start_time}`)
                        let end = moment(`2019-01-01 ${d.end_time}`)
                        let maxInterval = moment.duration(end.diff(start)).asMinutes() / d.interval

                        for (let i = 0; i < maxInterval; i++) {
                            if (!dayHours.hasOwnProperty(d.dow)) {
                                dayHours[d.dow] = []
                            }
                            let firstTime = start.format('HH:mm')
                            let nextTime = start.add(d.interval, 'minutes').format('HH:mm')

                            dayHours[d.dow].push(`${firstTime} - ${nextTime}`)
                            dayHours[d.dow].sort()

                            if (moment.duration(end.diff(start)).asMinutes() == 0) {
                                break;
                            }
                        }
                    } else {
                        let start = d.start_time.split(':')
                        let end = d.end_time.split(':')
                        dayHours[d.dow] = []
                        dayHours[d.dow].push(`${start[0]}:${start[1]} - ${end[0]}:${end[1]}`)
                        dayHours[d.dow].sort()
                    }
                })
                return dayHours
            }
        },
        watch: {
            'course.days'() {
                this.updateDays();
            }
        },
        mounted() {
            this.updateDays();
            $('[data-toggle="popover"]').popover()
        },
        methods: {
            toggleCollapse() {
                this.collapsed = !this.collapsed
            },
            updateDays() {
                let self = this;

                this.days.forEach(function (day) {
                    let isPresent = false;

                    self.course.days.forEach(function (course_day) {
                        if (course_day.dow === day.dow) {
                            isPresent = true;
                        }
                    });

                    day.lesson = isPresent;
                });
            },
            getImageBackground() {
                if (this.course.course_thumb_image && this.course.course_thumb_image != 'null') {
                    return {
                        'background-image': `url(${this.course.course_thumb_image_full})`
                    }
                }
                return {
                    'background-image': `url("${this.course.course_image}")`
                }

            },
            hrefCourse() {
                return `/corsi/${this.course.slug}`
            },
            hrefCoursePromotion() {
                return `/corsi/${this.course.slug}/avvicinamento`
            },
            hasPromotion() {
                return this.course.promotions.length > 0
            },
            existDayKey(key) {
                return this.dayHours.hasOwnProperty(key)
            },
            getChunkDayTimes(idx, chunk) {
                return _.chunk(this.dayHours[idx], chunk)
            },
            goToCoursePage(course) {
                return window.open(`/corsi/${course.slug}`)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SearchViewResultCourseContainer.vue